import {useCallback, useEffect, useState} from 'react'
import {loadTags} from './Api'
import {ITagModel} from './TagModel'

/** Etiket filtresi seçenekleri; yeni etiket oluşturulunca reload ile yenilenir */
export function useTagOptions() {
  const [tags, setTags] = useState<ITagModel[]>([])

  const reload = useCallback(() => {
    loadTags()
      .then(({data}) => setTags(data.payload))
      .catch(() => setTags([]))
  }, [])

  useEffect(() => {
    reload()
  }, [reload])

  return {tags, reloadTags: reload}
}
